<template>
  <div>
    <span @click.stop="drawer = !drawer" class="cursor-pointer"><v-icon>mdi-speedometer</v-icon></span>
    <v-sheet>
      <v-navigation-drawer v-model="drawer" absolute temporary>
        <v-divider></v-divider>

        <v-list dense>
          <v-list-item v-if="getAuthenticated">
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{getId}} - {{getLogin}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        </v-list>
      </v-navigation-drawer>
    </v-sheet>

  </div>

</template>

<script>
  import {mapActions, mapGetters} from 'vuex';
  import SwitchDarkMode from "@/components/left_widgets/SwitchDarkMode";

  export default {
    name: 'SidebarSettings',
    components: {SwitchDarkMode},
    data: () => ({
      drawer: null,
    }),
    computed: {
      ...mapGetters({
        'getAuthenticated': 'user/getAuthenticated',
        'getId': 'user/getId',
        'getLogin': 'user/getLogin',
      }),
    },
    methods: {
      ...mapActions({})
    }
  };
</script>
<style>

</style>